/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EuPagoInit } from './EuPagoInit';
import {
    EuPagoInitFromJSON,
    EuPagoInitFromJSONTyped,
    EuPagoInitToJSON,
} from './EuPagoInit';

/**
 * 
 * @export
 * @interface MoneyInMbwayInitOutput
 */
export interface MoneyInMbwayInitOutput {
    /**
     * 
     * @type {EuPagoInit}
     * @memberof MoneyInMbwayInitOutput
     */
    euPagoInit?: EuPagoInit;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInMbwayInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInMbwayInitOutput interface.
 */
export function instanceOfMoneyInMbwayInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInMbwayInitOutputFromJSON(json: any): MoneyInMbwayInitOutput {
    return MoneyInMbwayInitOutputFromJSONTyped(json, false);
}

export function MoneyInMbwayInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInMbwayInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'euPagoInit': !exists(json, 'euPagoInit') ? undefined : EuPagoInitFromJSON(json['euPagoInit']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInMbwayInitOutputToJSON(value?: MoneyInMbwayInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'euPagoInit': EuPagoInitToJSON(value.euPagoInit),
        'error': value.error,
    };
}

